import { render, staticRenderFns } from "./FilterSorting.vue?vue&type=template&id=4d62a53a&lang=pug&"
import script from "./FilterSorting.vue?vue&type=script&lang=js&"
export * from "./FilterSorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports